import React from "react";
import { Container, Row, Col } from "reactstrap";

// Import version from package.json using import
import packageJson from '../../package.json';

const Footer = () => (
  <footer className="footer">
    <Container fluid>
      <Row className="text-muted">
        <Col xs="5" className="text-left">
        <p className="mb-0">
            <span href="/" className="text-muted">
                 v {packageJson.version}             
            </span>
          </p>
        </Col>
        <Col xs="7" className="text-right">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} -{" "}
            <span href="/" className="text-muted">
              General Logic
            </span>
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
